import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { PRICE_REFETCH_INTERVAL } from 'settings';
import refetchPricesOperations from 'store/price/operation/refetchPricesOperations';

const PriceRefreshTicker = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(refetchPricesOperations());
    }, PRICE_REFETCH_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  return null;
};

export default PriceRefreshTicker;
